<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">Статические страницы</div>
      <div class="panel-body">
        <form>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label for="category" class="control-label">Страница:</label>
                <select id="category" class="form-control" v-model="selectedPage" @change="selectChange">
                  <option value="">-- Выберите страницу</option>
                  <option v-for="page in pages" :value="page" :key="page.name">
                    {{page.displayName}}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for="seo_title">Title</label>
                <input type="text" id="seo_title" class="form-control" v-model="data.seo_title"/>
              </div>
              <div class="form-group">
                <label for="seo_description">Description</label>
                <input type="text" id="seo_description" class="form-control" v-model="data.seo_description"/>
              </div>
              <div class="form-group">
                <label for="html">HTML код страницы</label>
                <textarea id="html" class="form-control" rows="20" v-model="data.html"></textarea>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-default" @click.prevent="store()">Сохранить</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {api} from '../http'

  var config = require('../config')

  export default {
    mounted () {
    },
    data () {
      return {
        url: config.appUrl,
        loaded: false,
        pages: [
          {
            name: 'delivery_page',
            displayName: 'Доставка и оплата'
          },
          {
            name: 'how_to_order_page',
            displayName: 'Как заказать'
          },
          {
            name: 'requisites_page',
            displayName: 'Реквизиты'
          },
          {
            name: 'privacy_page',
            displayName: 'Политика конфиденциальности'
          },
          {
            name: 'sitemap_page',
            displayName: 'Карта сайта'
          },
          {
            name: 'reviews_page',
            displayName: 'Отзывы'
          },
          {
            name: 'promotions_page',
            displayName: 'Акции'
          },
          {
            name: 'cart_delivery_page',
            displayName: 'Корзина'
          }
        ],
        data: {
          html: '',
          seo_title: '',
          seo_description: ''
        },
        selectedPage: null
      }
    },
    beforeCreate () {
    },
    methods: {
      store () {
        var formData = new FormData()
        formData.append('html', this.data.html)
        formData.append('seo_title', this.data.seo_title)
        formData.append('seo_description', this.data.seo_description)
        formData.append('name', this.selectedPage.name)

        api.post('settings/store', formData).then(response => {
          if (response.data.success) {
            this.data = response.data.data
          } else {
            // this.modalError = response.data.message
          }
        })
      },
      selectChange () {
        api.get('settings/show', {
          params: {
            name: this.selectedPage.name
          }
        }).then(response => {
          this.data.html = response.data.html
          this.data.seo_title = response.data.seo_title
          this.data.seo_description = response.data.seo_description
        })
      }
    }
  }
</script>

<style>
  .image-wrap {
    width: 370px;
    height: 248px;
    background-size: cover;
    border: 1px solid silver;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slider-text {
    width: 450px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminSettings/AdminSettingsStaticPage.vue